"use client";

import Link from "next/link";
import { useActionState, useId } from "react";
import { signup, type SignupState } from "@/app/newsletter/actions";
import "./newsletter.css";

type Props = { source: "startseite" | "newsletter" | "beitrag" | "seite" | "reisetipps"; button?: string };

/** Anmeldeformular für dunkle Flächen. Funktioniert auch ohne JavaScript (Server Action). */
export function NewsletterForm({ source, button = "Anmelden" }: Props) {
  const [state, action, pending] = useActionState<SignupState, FormData>(signup, { kind: "idle", text: "" });
  const id = useId();
  const done = state.kind === "ok" && !!state.text;

  return (
    <form action={action} className="nl-form">
      <input type="hidden" name="source" value={source} />
      <div className="nl-hp" aria-hidden="true">
        <label htmlFor={`${id}-w`}>Bitte leer lassen</label>
        <input id={`${id}-w`} name="website" type="text" tabIndex={-1} autoComplete="off" defaultValue="" />
      </div>
      {!done && (
        <>
          <label htmlFor={`${id}-e`} className="nl-label">Deine E-Mail-Adresse</label>
          <div className="nl-row">
            <input
              id={`${id}-e`} name="email" type="email" required maxLength={254} autoComplete="email" inputMode="email"
              placeholder="name@beispiel.de" className="nl-input" defaultValue={state.email ?? ""}
              aria-invalid={state.kind === "error" || undefined} aria-describedby={`${id}-s ${id}-n`}
            />
            <button type="submit" className="nl-btn" disabled={pending}>{pending ? "Einen Moment …" : button}</button>
          </div>
        </>
      )}
      <p id={`${id}-s`} className={`nl-status${state.kind === "error" ? " err" : ""}`} role={state.kind === "error" ? "alert" : "status"}>
        {state.text}
      </p>
      {!done && (
        <p id={`${id}-n`} className="nl-note">
          Du bekommst zuerst eine Mail zur Bestätigung. Abmelden geht jederzeit mit einem Klick. Kein Tracking von Öffnungen oder
          Klicks. Mehr in der <Link href="/datenschutz">Datenschutzerklärung</Link>.
        </p>
      )}
    </form>
  );
}
